import { gql } from "@apollo/client";

const CREATE_TOR = gql`
    mutation createToR(
        $laID: String!,
        $studyPeriodStart: String,
        $studyPeriodEnd: String,
        $torEwpId: String,
        $torEsi: String,
        $receivingAcademicYear: String,
        $torReceivingHeiId: String,
        $torSendingHeiId: String,
        $torStudentDateOfBirth: String,
        $torStudentFamilyName: String,
        $torStudentGivenNames: String,
        $torStudentCitizenship: JSON
    ){
        createToR(
            laID: $laID,
            studyPeriodStart: $studyPeriodStart,
            studyPeriodEnd: $studyPeriodEnd,
            torEwpId: $torEwpId,
            torEsi: $torEsi,
            receivingAcademicYear: $receivingAcademicYear,
            torReceivingHeiId: $torReceivingHeiId,
            torSendingHeiId: $torSendingHeiId,
            torStudentDateOfBirth: $torStudentDateOfBirth,
            torStudentFamilyName: $torStudentFamilyName,
            torStudentGivenNames: $torStudentGivenNames,
            torStudentCitizenship: $torStudentCitizenship
        )
  }
`;

export default CREATE_TOR;
